import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesTestXinkeForm {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext){
        if (webParameterContext.Client.PageName == "TestXinkeForm") {
            // console.log("88888888888888888");
            // if(webParameterContext.OpType =="add" || webParameterContext.OpType =="edite"){
            //     if(webParameterContext.ID && webParameterContext.OpType =="edite"){
            //         webContext.Status = webParameterContext.ID;
            //     }
            //     let _obj = {
            //         id:webContext.Status,
            //         url:"/tabs/contact/ListForm/"+webParameterContext.OpType+"/"+webContext.Status
            //     }
            //     webContext.Status = _obj;
            // }
        }
        return webContext;
    }
}